module.exports = __webpack_public_path__ + "static/assets/dd464953416e4b5de7936d6460f78f71.gif";